module.exports = __webpack_public_path__ + "img/accessExecutionsIcon.143ee47d.svg";